import { pessoaModel } from './pessoa'

export const colaboradorModel = {
  colaborador: function () {
    return {
      id: '',
      ds_obervacao: '',
      pessoa_id: '',
      pessoa: new pessoaModel.pessoa(),
    }
  }
}


// WEBPACK FOOTER //
// ./src/models/colaborador.js